import { render } from "./FireExtinguisherTable.vue?vue&type=template&id=0ab14b61&ts=true"
import script from "./FireExtinguisherTable.vue?vue&type=script&lang=ts"
export * from "./FireExtinguisherTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/admin.beepi.cl/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__